/**
 * Client-side helpers for COMP continuation email packs.
 * Opens the user's own mail client (mailto) — never sends via portal/alerts SMTP.
 *
 * Display fallback only — real To address comes from API emailPack.to
 * (backend COMP_CONTINUATION_TO_EMAIL).
 */

export const REQUESTS_EMAIL =
  process.env.REACT_APP_COMP_CONTINUATION_TO_EMAIL || 'requests@monarchinsurance.co.ke';

export function openContinuationMailto(emailPack) {
  if (!emailPack?.mailto) return false;
  try {
    window.location.href = emailPack.mailto;
    return true;
  } catch (_) {
    return false;
  }
}

export async function copyContinuationEmailPack(emailPack) {
  const text = [
    `To: ${emailPack?.to || REQUESTS_EMAIL}`,
    `Subject: ${emailPack?.subject || ''}`,
    '',
    emailPack?.body || ''
  ].join('\n');
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  // Fallback
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(ta);
  return ok;
}

export function formatDaysLeftLabel(daysLeft) {
  if (daysLeft == null) return '—';
  if (daysLeft === 0) return 'Expires today';
  if (daysLeft > 0) return `${daysLeft} day${daysLeft === 1 ? '' : 's'} left`;
  const overdue = Math.abs(daysLeft);
  return `Expired ${overdue} day${overdue === 1 ? '' : 's'} ago`;
}

export function formatKesDisplay(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return `KES ${v.toLocaleString('en-KE', { maximumFractionDigits: 0 })}`;
}
